function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IcheckSimple = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9195 5.27754C21.495 4.81393 20.9266 4.55859 20.3193 4.55859C19.7308 4.55859 19.1747 4.80089 18.7541 5.241L9.11616 15.3199L5.36214 11.4009C4.94146 10.9616 4.3859 10.7197 3.79739 10.7197C3.18945 10.7197 2.62087 10.9754 2.19632 11.4397C1.77837 11.8967 1.55178 12.5002 1.55875 13.1391C1.56557 13.7783 1.80499 14.376 2.23279 14.8226L7.55232 20.3772C7.97307 20.8165 8.52877 21.0586 9.11707 21.0586C9.70589 21.0586 10.2619 20.8161 10.6827 20.376L21.8852 8.6604C22.3129 8.21356 22.5522 7.61557 22.5585 6.9765C22.5649 6.33768 22.338 5.73426 21.9195 5.27754Z",
    fill: "white"
  }));
});